import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import {
  NestedQuota,
  QuotaPayload,
} from '../../../shared/interfaces/quota.interface';
import { UnicornQuotas } from '../../../shared/interfaces/unicorn.interface';
import { DifficultQuota } from '../../../shared/interfaces/feasibility.interface';

@Injectable({
  providedIn: 'root',
})
export class QuotaPayloadService {
  private _quotas$ = new BehaviorSubject<QuotaPayload[]>([]);
  private _nestedQuotas$ = new BehaviorSubject(<NestedQuota[]>[]);
  private _surveyUnicorns$ = new BehaviorSubject(<UnicornQuotas[]>[]);
  private _surveyDifficultQuotas$ = new BehaviorSubject<DifficultQuota[]>([]);

  constructor() {}

  setQuotas(quotas: QuotaPayload[]): void {
    this._quotas$.next(quotas);
  }

  getQuotas(): Observable<QuotaPayload[]> {
    return this._quotas$.asObservable();
  }

  setNestedQuotas(quotas: NestedQuota[]): void {
    this._nestedQuotas$.next(quotas);
  }

  getNestedQuotas(): Observable<NestedQuota[]> {
    return this._nestedQuotas$.asObservable();
  }

  setSurveyUnicorns(quotas: UnicornQuotas[]): void {
    this._surveyUnicorns$.next(quotas);
  }

  getSurveyUnicorns(): Observable<UnicornQuotas[]> {
    return this._surveyUnicorns$.asObservable();
  }

  setSurveyDifficultQuotas(quotas: DifficultQuota[]): void {
    this._surveyDifficultQuotas$.next(quotas);
  }

  getSurveyDifficultQuotas(): Observable<DifficultQuota[]> {
    return this._surveyDifficultQuotas$.asObservable();
  }

  resetData(): void {
    this._quotas$.next([]);
    this._nestedQuotas$.next([]);
    this._surveyUnicorns$.next([]);
    this._surveyDifficultQuotas$.next([]);
  }
}
